<template>
    <div
        class="order-menu-item-line"
        :class="{ 'order-menu-item-even-line': index % 2 === 0 }">
        <img
            :src="imageUrl"
            :style="imageStyle"
        />
        <div class="order-menu-item-name">
            {{ value.name }}
        </div>
        <a-icon
            v-on:click.stop="removeCommodityFromOrderList"
            :data-id="value.id"
            class="order-menu-minus-button"
            theme="filled"
            type="minus-circle" />
        <div class="order-menu-item-number">
            {{ number }}
        </div>
        <a-icon
            v-on:click.stop="addCommodityInOrderList"
            :data-id="value.id"
            class="order-menu-plus-button"
            theme="filled"
            type="plus-circle" />
    </div>
</template>

<script>
 import Vue from 'vue';

 export default {
     name: 'OrderItem',
     data() {
         return {
             size: 40
         }
     },
     props: {
         value: {},
         index: 0,
         number: 0
     },
     computed: {
         imageUrl: function() {
             return this.value.images[0].replace(/%/g, "%25") + "?x-oss-process=image/resize,w_" + this.size
         },
         imageStyle: function() {
             return "width: " + this.size + "px; height: " + this.size + "px; margin-left: 10px; border-radius: 5px;"
         }
     },
     components: {
     },
     methods: {
         removeCommodityFromOrderList(e) {
             this.$store.commit("removeCommodityFromShoppingList", parseInt(e.currentTarget.dataset.id))
         },
         addCommodityInOrderList(e) {
             this.$store.commit("addCommodityInShoppingList", parseInt(e.currentTarget.dataset.id))
         }
     }
 }
</script>

<style scoped>
 .order-menu-item-name {
     color: #666666;
     font-size: 12px;
     flex: 1;
     margin-left: 5px;
     margin-right: 5px;
 }

 .order-menu-item-number {
     color: #333;
     font-size: 18px;
     width: 40px;
     text-align: center;
 }

 .order-menu-plus-button {
     color: #AAA;
     font-size: 16px;
     margin-right: 10px;
 }

 .order-menu-plus-button:hover {
     color: #5DC55C;
     font-size: 16px;
 }

 .order-menu-minus-button {
     color: #AAA;
     font-size: 16px;
     margin-left: 5px;
 }

 .order-menu-minus-button:hover {
     color: #D80E3B;
     font-size: 16px;
 }
</style>
